var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdobePhotoshopCc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-362.4 459.1 500 500",
    enableBackground: "new -362.4 459.1 500 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: -1002.9117,
    cy: 1088.6686,
    r: 0.6371,
    gradientTransform: "matrix(545.6736 0 0 -528.3113 547071.625 575749.0625)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#34364E",
      stopOpacity: 0.98
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0C0824"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M-341.6,493.3h457.5v445h-457.5V493.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#31C5F0",
    d: "M-341.6,493.3h457.5v445h-457.5V493.3z M-362.4,959.1h499V472.5h-499V959.1z M-25.9,672.2 c-16.4,0-22,8.3-22,15.2c0,7.5,3.7,12.7,25.8,24.1c32.6,15.8,42.8,31,42.8,53.2c0,33.3-25.4,51.2-59.7,51.2 c-18.1,0-33.7-3.7-42.6-8.9c-1.5-0.6-1.7-1.7-1.7-3.3V773c0-2.1,1-2.7,2.5-1.7c13.1,8.5,28.1,12.3,41.8,12.3 c16.4,0,23.3-6.9,23.3-16.2c0-7.5-4.8-14.1-25.8-25C-71,728.3-83.3,714-83.3,690c0-26.8,21-49.1,57.4-49.1c17.9,0,30.4,2.7,37.2,5.8 c1.7,1,2.1,2.7,2.1,4.2v28.5c0,1.7-1,2.7-3.1,2.1C1.1,675.7-12.4,672.2-25.9,672.2L-25.9,672.2z M-204.7,696.9 c4.8,0.4,8.5,0.4,16.8,0.4c24.3,0,47.2-8.5,47.2-41.6c0-26.4-16.4-39.7-44.1-39.7c-8.3,0-16.2,0.4-20,0.6L-204.7,696.9L-204.7,696.9 z M-241.8,586.5c0-1.5,2.9-2.5,4.6-2.5c13.3-0.6,33.1-1,53.6-1c57.6,0,80.1,31.6,80.1,71.9c0,52.8-38.3,75.5-85.3,75.5 c-7.9,0-10.6-0.4-16.2-0.4v79.8c0,1.7-0.6,2.5-2.5,2.5h-31.8c-1.7,0-2.5-0.6-2.5-2.5L-241.8,586.5L-241.8,586.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdobePhotoshopCc);
export default __webpack_public_path__ + "static/media/adobe-photoshop-cc.a8dc0673b0d95f685e779a2a7a29940f.svg";
export { ForwardRef as ReactComponent };